import { ConfigNamesEnum } from 'store/storeTypes';
import { config } from '../config';

const configMobileDevAndroid: config = {
  AUTH_CONFIG_STR: {
    domain: 'dev-sbafxfr4.eu.auth0.com',
    clientID: 'kU6E86Xq2JlUhWXuFGPa0YDGQXESx8wp',
    redirectUri: 'https://devkonnectadmindata.z6.web.core.windows.net',
    audience: 'https://dev.konnect.kornit.com',
    returnTo: 'https://devkonnectadmindata.z6.web.core.windows.net',
  },
  API_ROUTER_HOST: 'https://dev-konnect-admin-handlers.azurewebsites.net/api/portalUrl',
  AUTH0_CLAIMS_NAMESPACE: 'https://schemas.dev-sbafxfr4.com/',
  SELF_HOST: 'https://devkonnectadmindata.z6.web.core.windows.net',
  USER_LOGOUT_TIMEOUT: 14400000,
  WEEK_START: 1,
  FILTER_HIDE: false,
  USER_AGREEMENT_VERSION: 1.5,
  SHOW_PBI_REPORT_PAGES_PANE: false,
  SHOW_PBI_REPORT_FILTERS_PANE: false,
  REPORTS_REFRESH_TIMEOUT_SECONDS: 300,
  MAX_LOAD_ATTEMPTS: 5,
  SPLIT_WEEK_BY_END_OF_YEAR: true,
  ENV_NAME: ConfigNamesEnum.Dev,
  PLATFORM: 'android',
  SHOW_VERSION_VERSION_LABEL: true,
  GENERATE_SOURCEMAP: true,
  LOGGER_INSTRUMENTAION_KEY: 'c8412821-c572-465c-a2c6-35dd1b2c3fb3',
  REFRESH_API_INTERVAL: 600000,
  MIXPANEL_KEY: 'e361850fceb820d591e0cc1d6b1732cf',
  GOOGLE_ANALYTICS_KEY: 'UA-187586006-3',
  UNSUBSCRIBE_END_POINT:
    'https://dev-konnect-portal.kornitkonnect.com/api/email-reports-scheduler/unsubscribe',
  SERVICE_TICKET_END_POINT: 'https://SandboxKornit.formtitan.com/CaseFormJuly',
  BLOB_URL: 'https://devconnectportaldata.blob.core.windows.net',
  API_URL: 'https://dev-konnect-portal.kornitkonnect.com',
  RECAPTCHA_KEY: '6LdzndIjAAAAANQ7LVjhg7siwpSWmVM3A9YkXai8',
};
export default configMobileDevAndroid;
